module.exports = __webpack_public_path__ + "static/media/img104.7b55c646.png";